import React, { useState } from 'react';

import { useAnalytics } from '@/hooks/useAnalytics';
import { useMobile } from '@/hooks/useMobile/useMobile';

import FormButtonOwner from '@/components/OwnerPage/FormButtonOwner';
import ModalPropertyLock from '@/components/OwnerPage/Modal/ModalPropertyLock';

import { ButtonContainer } from './styles';

interface Props {
  className: string;
}

const RequestBlockProperty = ({ className }: Props) => {
  const { isDesktop } = useMobile();
  const { dispatchEvent } = useAnalytics();
  const [openModalPropertyLock, setOpenModalPropertyLock] = useState<boolean>(false);

  const handleClick = () => {
    dispatchEvent({ action: 'Clicou em solicitar bloqueio do imóvel no botão principal' });
    setOpenModalPropertyLock(true);
  };

  return (
    <>
      <ButtonContainer className={className}>
        <FormButtonOwner
          dataCy="btn-blocking"
          variant={isDesktop ? 'outlined' : undefined}
          onClick={handleClick}
        >
          Solicitar bloqueio do imóvel
        </FormButtonOwner>
      </ButtonContainer>
      <ModalPropertyLock
        openModalPropertyLock={openModalPropertyLock}
        onClose={setOpenModalPropertyLock}
        dataCy="modal-1"
      />
    </>
  );
};

export default RequestBlockProperty;
